import { render, staticRenderFns } from "./cart.vue?vue&type=template&id=04db7c70&scoped=true"
import script from "./cart.vue?vue&type=script&lang=js"
export * from "./cart.vue?vue&type=script&lang=js"
import style0 from "./cart.vue?vue&type=style&index=0&id=04db7c70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04db7c70",
  null
  
)

export default component.exports